import { render, staticRenderFns } from "./appointmentService.vue?vue&type=template&id=47c7efd7&scoped=true&"
import script from "./appointmentService.vue?vue&type=script&lang=js&"
export * from "./appointmentService.vue?vue&type=script&lang=js&"
import style0 from "./appointmentService.vue?vue&type=style&index=0&id=47c7efd7&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c7efd7",
  null
  
)

export default component.exports